import React, { useEffect } from "react";
import Navbar from "../components/navbar";
import "../styles/home.css";
import htmlIcon from "../assets/img/html-icon.svg";
import cssIcon from "../assets/img/css-icon.svg";
import jsIcon from "../assets/img/js-icon.svg";
import reactIcon from "../assets/img/react-icon.svg";
import nodeIcon from "../assets/img/node-icon.svg";
import photoshopIcon from "../assets/img/photoshop-icon.svg";
import illustratorIcon from "../assets/img/illustrator-icon.svg";
import figmaIcon from "../assets/img/figma-icon.svg";
import mysqlIcon from "../assets/img/mysql-icon.svg";
import pythonIcon from "../assets/img/python-icon.svg";
import firebaseIcon from "../assets/img/firebase-icon.svg";
import githubIcon from "../assets/img/github-icon.svg";
import linkedinIcon from "../assets/img/linkedin-icon.svg";
import instagramIcon from "../assets/img/insta-icon.svg";
import behanceIcon from "../assets/img/behance-icon.svg";
import emyIcon from "../assets/img/emy-circle.svg";
import Footer from "../components/footer";
import PlanoDiretor from "../assets/img/planodiretor-mockup.png";
import RandomFood from "../assets/img/RandomFood-mockup.png";
import ProgramaOrla from "../assets/img/ProgramaOrla-mockup.png";
import NovoCentro from "../assets/img/NovoCentro-mockup.png";
import NegociodaGrota from "../assets/img/negociodagrota-mockup.png";
import Celer from "../assets/img/celer-mockup.png";
import BoraLab from "../assets/img/Boralab-mockup.png";
import Esaj from "../assets/img/Esaj-mockup.png";
import Experimenta from "../assets/img/ExperimentaMaceio-mockup.png";
import Portifolio from "../assets/img/portfolio-mockup.png";
import { Analytics } from "@vercel/analytics/react";

function scrollLeft() {
  const galeriaProjetos = document.querySelector(".galeria-projetos");
  galeriaProjetos.scrollLeft -= 300; // Ajuste a quantidade de rolagem como preferir
}

function scrollRight() {
  const galeriaProjetos = document.querySelector(".galeria-projetos");
  galeriaProjetos.scrollLeft += 300;
}

function Home() {
  useEffect(() => {
    const galeriaProjetos = document.querySelector(".galeria-projetos");

    const handleWheel = (event) => {
      if (event.deltaY !== 0) {
        galeriaProjetos.scrollLeft += event.deltaY;
        event.preventDefault();
      }
    };

    galeriaProjetos.addEventListener("wheel", handleWheel);

    // Cleanup function to remove the event listener
    return () => {
      galeriaProjetos.removeEventListener("wheel", handleWheel);
    };
  }, []);
  return (
    <div className="Home">
      <Analytics/>
      <Navbar />
      <div className="content">
        <div className="header" id="sobre">
          <h1>@EmyChrystinne</h1>
          <p>Oi! Pode me chamar de Emy :D </p>
          <p>
            {" "}
            <strong>
              Sou apaixonada por transformar ideias em interfaces incríveis e
              funcionais.
            </strong>{" "}
            Com foco em UI/UX Design e desenvolvimento Front-end, adoro criar
            experiências digitais que encantam e facilitam a vida dos usuários.{" "}
          </p>
          <p>
            Se você está buscando alguém para trazer inovação e eficiência ao
            seu projeto, vamos conversar!
          </p>
        </div>
        <div className="projetos" id="projetos">
          <h1>Conheça meus Projetos</h1>
          <button className="arrow" onClick={scrollLeft}>←</button>
          <div className="galeria-projetos">
            <div className="projeto">
              <img src={RandomFood} alt="Random Food" />
              <h2>Random Food</h2>
              <p>
                Na dúvida do que comer? Deixe o Random Food decidir por você!
                Descubra aleatoriamente os restaurantes e deixe a sorte guiar
                sua próxima refeição.
              </p>
              <div className="botoes">
                <a href="https://randomfood.com.br" id="acesse">
                  Acesse
                </a>
                <a href="https://www.figma.com/proto/n7ntEMJ16M7gNFYjhjQtaX/RandomFood-%7C-Site-%7C-WhiteMode?page-id=0%3A1&node-id=1-13&node-type=CANVAS&viewport=703%2C561%2C0.21&t=59YvhPSD38BWjzXS-1&scaling=scale-down&content-scaling=fixed">
                  Figma
                </a>
              </div>
            </div>
            <div className="projeto">
              <img src={PlanoDiretor} alt="Plano Diretor" />
              <h2>Plano Diretor de Maceió</h2>
              <p>
                Define estratégias para o crescimento sustentável da cidade, com
                foco em mobilidade, meio ambiente e desenvolvimento urbano.{" "}
              </p>
              <div className="botoes">
                <a href="https://planodiretor.maceio.al.gov.br/" id="acesse">
                  Acesse
                </a>
                <a href="https://www.figma.com/proto/BvgdC1gr4y2oNNfhuEDsRG/Plano-Diretor-%7C-Site?page-id=0%3A1&node-id=2-2&node-type=FRAME&viewport=93%2C-270%2C0.22&t=zlxQoG7NXtlgG9Ed-1&scaling=min-zoom&content-scaling=fixed">
                  Figma
                </a>
              </div>
            </div>
            <div className="projeto">
              <img src={Portifolio} alt="Portifolio" />
              <h2>Portifólio | Você está aqui!</h2>
              <p>
                Aqui estão meus melhores projetos e, claro, esse também é um
                deles! Feito com carinho e um toque de ‘olha o que eu sei
                fazer’. Vai lá, <strong>clica nos outros!</strong>
              </p>
              <div className="botoes">
                <a href="https://www.figma.com/proto/xjigUruQ60Wo6LQI4fgd0e/Portif%C3%B3lio?page-id=0%3A1&node-id=7-28&node-type=FRAME&viewport=427%2C338%2C0.48&t=XUzMzuoXLaAxq4UZ-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=7%3A28">
                  Figma
                </a>
              </div>
            </div>
            <div className="projeto">
              <img src={NegociodaGrota} alt="Negocio da Grota" />
              <h2>Negócio da Grota</h2>
              <p>
                Empreendedores das comunidades de Maceió ganham visibilidade com
                o Negócio da Grota. Uma vitrine de talentos locais e suas
                iniciativas.
              </p>
              <div className="botoes">
                <a href="https://negociodagrota.maceio.al.gov.br/" id="acesse">
                  Acesse
                </a>
              </div>
            </div>
            <div className="projeto">
              <img src={NovoCentro} alt="Novo Centro" />
              <h2>Novo Centro de Maceió</h2>
              <p>
                Revitalização com foco em moradia e preservação histórica. Três
                planos guiam o projeto: habitação, economia local e valorização
                cultural.
              </p>
              <div className="botoes">
                <a href="https://novocentro.maceio.al.gov.br" id="acesse">
                  Acesse
                </a>
              </div>
            </div>
            <div className="projeto">
              <img src={Esaj} alt="Esaj" />
              <h2>E-saj | Projeto de Estudo</h2>
              <p>
                Redesign moderno do portal, que busca facilitar a troca de informações
                e agilizar o trâmite processual através de serviços web para todos.
              </p>
              <div className="botoes">
                <a href="https://www.figma.com/proto/Sy7mh0CpXzsglc5uPYh9op/ESaj---TJAL?page-id=94%3A219&node-id=94-220&node-type=CANVAS&viewport=718%2C473%2C0.57&t=vwTcHq0Kcn9K21wP-1&scaling=min-zoom&content-scaling=fixed">
                  Figma
                </a>
              </div>
            </div>
            <div className="projeto">
              <img src={ProgramaOrla} alt="Programa Orla" />
              <h2>Programa Orla de Maceió</h2>
              <p>
                Promover um planejamento integrado para otimizar a gestão das
                áreas costeiras, com foco na qualidade ambiental e no uso
                racional dos espaços.
              </p>
              <div className="botoes">
                <a href="https://programaorla.maceio.al.gov.br/" id="acesse">
                  Acesse
                </a>
              </div>
            </div>
            <div className="projeto">
              <img src={Experimenta} alt="Experimenta Maceió" />
              <h2>Experimenta Maceió</h2>
              <p>
                Hora de experimentar o que Maceió tem de melhor! Um projeto que
                mistura cultura, gastronomia e muita criatividade, feito pra
                quem ama explorar.
              </p>
              <div className="botoes">
                <a href="https://www.behance.net/gallery/151676087/Experimente-Maceio">
                  Behance
                </a>
              </div>
            </div>
            <div className="projeto">
              <img src={BoraLab} alt="Boralab" />
              <h2>BoraLab</h2>
              <p>
                Inovação para todos! Espaço onde ideias se transformam em
                realidade. Um ambiente colaborativo que promove o
                empreendedorismo e a inovação.
              </p>
              <div className="botoes">
                <a href="https://boralab.maceio.al.gov.br/" id="acesse">
                  Acesse
                </a>
                <a href="https://www.behance.net/gallery/151676973/BoraLAB">
                  Behance
                </a>{" "}
              </div>
            </div>
            <div className="projeto">
              <img src={Celer} alt="Celer" />
              <h2>Celer</h2>
              <p>
              Centraliza resultados de corridas, oferecendo estatísticas de desempenho e evolução, inscrições em eventos e ainda mais.
              </p>
              <div className="botoes">
                <a href="https://emychrystinne.github.io/" id="acesse">
                  Acesse
                </a>
                <a href="https://www.behance.net/gallery/151677737/Celer-Em-Desenvolvimento">
                  Behance
                </a>{" "}
              </div>
            </div>

          </div>
            <button className="arrow" onClick={scrollRight}>→</button>
        </div>
        <div className="conhecimentos" id="conhecimentos">
          <h1>Conhecimentos</h1>
          <div className="habilidades">
            <div className="habilidade">
              <img src={nodeIcon} alt="Node.js Icon" />
            </div>
            <div className="habilidade">
              <img src={reactIcon} alt="Node.js Icon" />
            </div>
            <div className="habilidade">
              <img src={htmlIcon} alt="Node.js Icon" />
            </div>
            <div className="habilidade">
              <img src={cssIcon} alt="Node.js Icon" />
            </div>
            <div className="habilidade">
              <img src={jsIcon} alt="Node.js Icon" />
            </div>
            <div className="habilidade">
              <img src={figmaIcon} alt="Node.js Icon" />
            </div>
            <div className="habilidade">
              <img src={photoshopIcon} alt="Node.js Icon" />
            </div>
            <div className="habilidade">
              <img src={illustratorIcon} alt="Node.js Icon" />
            </div>
            <div className="habilidade">
              <img src={pythonIcon} alt="Node.js Icon" />
            </div>
            <div className="habilidade">
              <img src={mysqlIcon} alt="Node.js Icon" />
            </div>
            <div className="habilidade">
              <img src={firebaseIcon} alt="Node.js Icon" />
            </div>
          </div>
        </div>
        <div className="trajetoria" id="trajetoria">
          <h1>Conheça minha trajetoria</h1>
          <div className="timeline">
            <div className="container left">
              <div className="line">
                <h2>2010</h2>
                <h3>Paixão pela Tecnologia</h3>
                <p>
                  Minha jornada na tecnologia começou cedo, já com 4 anos
                  auxiliava a minha tia, professora de informatica, a dar aulas
                  para meus coleguinhas de sala.
                </p>{" "}
                <p>
                  {" "}
                  Em 2010 tive meu primeiro contato com programação,
                  especificamente html e css e foi aqui que tudo começou.
                </p>
              </div>
            </div>
            <div className="container right">
              <div className="line">
                <h2>2015</h2>
                <h3>Descoberta de Eventos & Comunidades</h3>
                <p>
                  Foi nesse ano que mergulhei com tudo no mundo da programação,
                  participando de eventos de T.I., onde conheci outras mulheres
                  da àrea.{" "}
                  <p>
                    {" "}
                    Essa descoberta abriu um mundo de possibilidades e, em
                    parceria com organizações mundiais, fundei o como{" "}
                    <a href="https://www.instagram.com/djangogirlsmaceio/">
                      Django Girls Maceió
                    </a>{" "}
                    e o PyLadies Maceió.
                  </p>{" "}
                  <p>
                    {" "}
                    <strong>
                      Meu papel era claro: ajudar outras mulheres a explorar a
                      tecnologia enquanto eu mesma descobria a minha paixão.
                    </strong>
                  </p>
                </p>
              </div>
            </div>
            <div className="container left">
              <div className="line">
                <h2>2018</h2>
                <h3>Ingresso em BSI do IFAL</h3>
              </div>
            </div>
            <div className="container right">
              <div className="line">
                <h2>2019</h2>
                <h3>Primeiro Estágio em T.I.</h3>
                <p>
                  Fui contratada para meu primeiro estágio em T.I. como
                  Desenvolvedora, onde tive a oportunidade de trabalhar com
                  desenvolvimento web e desktop.
                </p>{" "}
                <p>
                  Foi nessa época que descobri que minha maior paixão se
                  encontra em{" "}
                  <strong>
                    design de interfaces e desenvolvimento front-end.
                  </strong>{" "}
                </p>{" "}
                <p>Amo ver minhas criações tomando vida!</p>
              </div>
            </div>
            <div className="container left">
              <div className="line">
                <h2>2021 | Atual</h2>
                <h3>Gerente de Tecnologia</h3>
                <p>
                  Atualmente, sou responsável por toda a área de Tecnologia de
                  uma secretaria do setor público. Minha atuação abrange a
                  gestão de todas as plataformas web, desde a criação até a
                  manutenção, assegurando que cada site e sistema esteja
                  funcionando de forma eficiente e com alta usabilidade.
                </p>
                <p>
                  Além disso, coordeno a equipe de TI, englobando todas as áreas
                  desde a administração da infraestrutura e redes até o
                  desenvolvimento de software. Minha função requer uma visão
                  estratégica, pois, além de resolver problemas técnicos do dia
                  a dia, também gerencio a segurança da informação e planejo a
                  evolução tecnológica da organização.
                </p>
                <p>
                  <strong>
                    O meu trabalho é um equilíbrio entre desenvolvimento prático
                    e gestão estratégica, onde, além de resolver desafios
                    técnicos, também lidero a equipe e contribuo para a inovação
                    e eficiência tecnológica.
                  </strong>
                </p>
                <p>
                  Além disso, sou co-fundadora da{" "}
                  <a href="https://www.instagram.com/noname.tecnology/">
                    Noname Technology
                  </a>
                  , uma empresa de assistência técnica e manutenção de
                  computadores e notebooks.
                </p>
                <p>
                  <strong>
                    Estou disponível para novas oportunidades! Se você está procurando por
                    um profissional dedicado e com ampla experiência em
                    tecnologia e gestão, entre em contato!
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="contato" id="contato">
          <div className="sobre-pessoa">
            <div className="foto">
              <img src={emyIcon} alt="Emy Chrystinne" />
            </div>
            <div className="redes-sociais">
              <div className="curriculo">
                <p>
                  <strong>E então, vamos criar juntos?</strong> Estou em busca
                  de projetos que me desafiem a ir além no design de interfaces
                  e desenvolvimento front-end.
                </p>{" "}
                <p>
                  <strong>
                    Se você quer transformar seu site ou app em algo incrível,
                    estou pronta para ajudar!
                  </strong>
                </p>
                <a href="/docs/EmyChrystinne_CV.pdf" download id="botao-curriculo">
                  Baixar CV
                </a>
              </div>
              <div className="redes">
                <a href="https://www.instagram.com/emy.chrystinne/">
                  <img src={instagramIcon} alt="Instagram" />
                </a>
                <a href="https://www.linkedin.com/in/emychrystinne/">
                  <img src={linkedinIcon} alt="Linkedin" />
                </a>
                <a href="https://github.com/EmyChrystinne">
                  <img src={githubIcon} alt="Github" />
                </a>
                <a href="https://www.behance.net/emychrystinne">
                  <img src={behanceIcon} alt="Behance" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Home;
